import { HelperResult } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

export interface BirthInformation {
  birthDate?: string;
  country?: string;
  countryName?: string;
  googlePlaceId?: string;
  locality?: string;
  state?: string;
}

const { useGet: useBirthInformation, useUpdate: useUpdateBirthInformation } = getCRUDHooks({
  entityName: 'birthInformation',
  get: ({ userId }: { userId: number }): HelperResult<BirthInformation> =>
    clientApi.getOCClient().helpers.user.users.getBirthInformation(userId),
  update: (
    birthInformation: Partial<BirthInformation>,
    { userId, context }: { userId: number; context: string }
  ): HelperResult<BirthInformation> =>
    clientApi
      .getOCClient()
      .helpers.user.users.partialUpdateBirthInformation(userId, birthInformation, { context }),
});

export { useBirthInformation, useUpdateBirthInformation };
